module.exports = __webpack_public_path__ + "img/main-desktop.aae86f3b.webp";